import React from 'react';
import { StatusToast } from '@fiverr-private/orca';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { DEFAULT_ERROR_KEY, ERROR_COPY_ROOT } from './constants';

const raiseGeneralError = (errorKey = DEFAULT_ERROR_KEY) => {
    const { locale } = getContext();

    StatusToast.raise({
        message: <I18n k={`${ERROR_COPY_ROOT}.${errorKey}`} locale={locale}/>,
        theme: StatusToast.THEMES.ERROR
    });
};

export default raiseGeneralError;
